import { render, staticRenderFns } from "./SimilarProductsCollapse.vue?vue&type=template&id=6a1c1884&"
import script from "./SimilarProductsCollapse.vue?vue&type=script&lang=js&"
export * from "./SimilarProductsCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports